import React, { useContext } from 'react';
import AppContext from '../../context/AppContext';
import './Menu.css'
import { Link } from 'react-router-dom';

function Menu(props) {

  const { userData, setIsLogged } = useContext(AppContext);

  const { setOpenMenu } = props;

  const logout = () => {
    setIsLogged(false);
    sessionStorage.removeItem('login');
  };

  const validateRole = () => {
    const role = userData.role;
    if (role === 'admin') {
      return (
        <div className="user-menu">
          <li onClick={ () => setOpenMenu(false) }><Link to="/"><button className="menu-control screen-title">Home</button></Link></li>
          <li onClick={ () => setOpenMenu(false) }><Link to="/cadastro/itens"><button className="menu-control screen-title">Novo/Editar Produto</button></Link></li>
          <li onClick={ () => setOpenMenu(false) }><Link to="/meus-pedidos"><button className="menu-control screen-title">Todos Pedidos</button></Link></li>
          <li onClick={ () => setOpenMenu(false) }><Link to="/login"><button className="menu-control screen-title">Cadastrar Empregado</button></Link></li>
          <li onClick={ () => setOpenMenu(false) }><button disabled className="menu-control screen-title">Editar usuário</button></li>
          <li onClick={ () => setOpenMenu(false) }><button type="button" onClick={(logout)} className="menu-control screen-title">Sair</button></li>
        </div>
      )
    } else if (role === 'seller') {
      return (
        <div className="user-menu">
          <li onClick={ () => setOpenMenu(false) }><Link to="/cadastro/itens"><button className="menu-control screen-title">Novo/Editar Produto</button></Link></li>
          <li onClick={ () => setOpenMenu(false) }><Link to="/meus-pedidos"><button className="menu-control screen-title">Todos Pedidos</button></Link></li>
          <li onClick={ () => setOpenMenu(false) }><button type="button" onClick={(logout)} className="menu-control screen-title">Sair</button></li>
        </div>
      )
    } else {
      return (
        <div className="user-menu">
          <li onClick={ () => setOpenMenu(false) }><Link to="/meus-pedidos"><button className="menu-control screen-title">Meus Pedidos</button></Link></li>
          <li onClick={ () => setOpenMenu(false) }><button type="button" onClick={(logout)} className="menu-control screen-title">Sair</button></li>
        </div>
      )
    }
  };

  return (
    <nav className="top-menu">
      <h2 className='screen-title'>Olá, {userData.name}</h2>
      <menu className="user-menu">
        {
          userData.role ? validateRole() : null
        }
      </menu>
    </nav>
  )
}

export default Menu